import type { ApolloQueryResult } from '@apollo/client';
import { useState } from 'react';

export type Pagination = {
  hasMore: boolean;
  fetchMore: () => Promise<void>;
};

type FetchMoreFn<TData> = (options: { variables: { seite: number; anzahlProSeite: number } }) => Promise<ApolloQueryResult<TData>>;

export const usePagination = () => {
  const initialPage = 1;
  const [currentPage, setCurrentPage] = useState(initialPage);
  const entriesPerPage = 25;
  const nextPage = currentPage + 1;

  return {
    initialPage,
    currentPage,
    setCurrentPage,
    nextPage,
    entriesPerPage,
    paginationVariables: {
      seite: initialPage,
      anzahlProSeite: entriesPerPage * currentPage,
    },
    async fetchNextPage<TData>(fetchMore: FetchMoreFn<TData>) {
      await fetchMore({
        variables: {
          seite: nextPage,
          anzahlProSeite: entriesPerPage,
        },
      });
      setCurrentPage(nextPage);
    },
  };
};
